import script from "./device-info.vue?vue&type=script&lang=ts&setup=true"
export * from "./device-info.vue?vue&type=script&lang=ts&setup=true"

import "./device-info.vue?vue&type=style&index=0&id=36dd01a5&lang=scss&scoped=true"

import exportComponent from "D:\\web\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36dd01a5"]])

export default __exports__